import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import CanonicalUrl from '../components/CanonicalUrl'
import SchemaMarkup from '../components/SchemaMarkup'
import StatusCode from '../components/StatusCode'

/**
 * Componente NotFound para manejar rutas no encontradas (404)
 * @returns {JSX.Element} - Componente de página no encontrada
 */
const NotFound = () => {
  useEffect(() => {
    // Actualizar el título de la página
    document.title = 'Página no encontrada | Conversor IAE CNAE'
  }, [])

  return (
    <div className='container'>
      {/* Establecer el código de estado HTTP 404 */}
      <StatusCode code={404} />

      {/* Canonical URL */}
      <CanonicalUrl url='https://conversoriaecnae.es/404' />

      {/* Schema.org markup */}
      <SchemaMarkup
        type='BreadcrumbList'
        data={{
          itemListElement: [
            {
              position: 1,
              name: 'Inicio',
              item: 'https://conversoriaecnae.es',
            },
            {
              position: 2,
              name: 'Página no encontrada',
              item: 'https://conversoriaecnae.es/404',
            },
          ],
        }}
      />

      <div className='bg-surface rounded-lg p-6 my-6 text-center'>
        <h1 className='text-2xl font-bold mb-4'>Página no encontrada</h1>

        <div className='mb-8'>
          <p className='text-text-primary mb-4'>
            Lo sentimos, la página que está buscando no existe o ha sido movida.
          </p>
          <p className='text-text-secondary mb-6'>
            Puede que haya escrito mal la dirección o que la página se haya
            movido.
          </p>
        </div>

        <div className='flex flex-col md:flex-row justify-center gap-4 mb-8'>
          <Link
            to='/'
            className='bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary-dark transition-colors'
          >
            Volver a la página principal
          </Link>

          <Link
            to='/epigrafes-iae/'
            className='bg-iae text-white px-6 py-3 rounded-lg hover:opacity-90 transition-opacity'
          >
            Directorio IAE
          </Link>

          <Link
            to='/codigos-cnae-2025/'
            className='bg-cnae text-white px-6 py-3 rounded-lg hover:opacity-90 transition-opacity'
          >
            Directorio CNAE 2025
          </Link>
        </div>

        <div className='mt-8 p-4 bg-card rounded-lg'>
          <h2 className='text-lg font-semibold mb-2'>
            ¿Buscando un código específico?
          </h2>
          <p className='mb-4'>
            Utilice nuestro buscador en la página principal para encontrar
            rápidamente cualquier código IAE o CNAE.
          </p>
          <Link to='/' className='text-primary hover:underline'>
            Ir al buscador
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound
